import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import trincomalee1 from '../../img/webp/trincomalee1.webp';
import trincomalee2 from '../../img/webp/trincomalee2.webp';
import trincomalee3 from '../../img/webp/trincomalee3.webp';
import trincomalee4 from '../../img/webp/trincomalee4.webp';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';

const Trincomalee = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Trincomalee information..." />
      
      <div ref={contentRef}>
      {/* Hero Section */}
      <section className="dest-hero">
        <img src={trincomalee1} alt="Trincomalee" />
        <div className="dest-badge">Trincomalee</div>
      </section>

      {/* Main Content Section */}
      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img src={trincomalee2} alt="Trincomalee beach" />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Discover Trincomalee</h1>
              <p className="dest-description">
                A historic coastal city with pristine beaches and temples.
              </p>
              
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Beach relaxation
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Cultural sightseeing
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Smooth travel
                </li>
              </ul>

              <div className="dest-meta">
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Land Trip</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>2 Days</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Beach & Sightseeing</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Trincomalee is a historic port city on Sri Lanka's northeast coast, famous for its pristine beaches, natural harbor, and cultural landmarks. The area features stunning beaches like Nilaveli and Uppuveli with crystal-clear waters, perfect for swimming, snorkeling, and diving. Trincomalee's coastline is also a prime location for whale and dolphin watching.
              </p>
              <p className="dest-bottom-text">
                Historical attractions include Fort Frederick, Koneswaram Temple perched on Swami Rock, and hot springs at Kanniya. The blend of natural beauty, marine life, and cultural heritage makes Trincomalee a captivating and diverse destination.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img src={trincomalee3} alt="Trincomalee coast" />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img src={trincomalee4} alt="Ceylon D Tour Trincomalee experience" />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour offers comprehensive Trincomalee travel packages with comfortable transportation, beach excursions, whale watching arrangements, and cultural tours. Our services include visits to historic temples, fort explorations, hot springs, and snorkeling spots. With flexible itineraries and accommodation assistance, Ceylon D Tour ensures a memorable coastal adventure combining relaxation, marine wildlife, and cultural discovery in Trincomalee.
              </p>
            </div>
          </div>

          {/* Destination Suggestions */}
          <DestinationSuggestions 
            currentDestination="Trincomalee"
            suggestions={getRandomSuggestions('/places/trincomalee', 4)}
          />
        </div> {/* End of dest-container */}
      </section>
      </div>
    </div>
  );
};

export default Trincomalee;

